/*
 * NEW DS3 WCAG 2AA SPEC COLORS
 */

export const black = "#2E3A47";

// Greens
// export const green100 = "#1B533F";
// export const green90 = "#15694C";
// export const green80 = "#1D7656";
// export const green70 = "#26805F";
// export const green30 = "#46977C";
// export const green20 = "#69BFA3";
// export const green10 = "#A3DCC9";
// export const green05 = "#ECFCF6";

// Grays
export const gray100 = "#2E3A47";
export const gray90 = "#36485C";
export const gray80 = "#415B73";
export const gray70 = "#58728C";
export const gray30 = "#9BB1C7";
export const gray20 = "#C5D7E5";
export const gray10 = "#F0F5FC";
export const gray05 = "#F5F8FC";

// Blues
export const blue100 = "#183C5E";
export const blue90 = "#1E4D78";
export const blue80 = "#215F8F";
export const blue70 = "#3175A8";
export const blue30 = "#BED4E8";
export const blue20 = "#A8D0E5";
export const blue10 = "#EBF1F7";
export const blue05 = "#F6F9FC";

// Reds
export const red100 = "#640C29";
export const red90 = "#971038";
export const red80 = "#B91C3F";
export const red70 = "#DA1B46";
export const red30 = "#E1496B";
export const red20 = "#F98FA6";
export const red10 = "#FFDCE3";
export const red05 = "#FFF9FA";

// Orange
export const orange100 = "#B4561D";
export const orange90 = "#D96824";
export const orange80 = "#E57812";
export const orange70 = "#F89C1C";
export const orange30 = "#FCCB88";
export const orange20 = "#FFE6C4";
export const orange10 = "#FFF5E8";
export const orange05 = "#FFFBF6";

// Purples
export const purple100 = "#2E0141";
export const purple90 = "#401256";
export const purple80 = "#58316B";
export const purple70 = "#816290";
export const purple30 = "#B69AC4";
export const purple20 = "#CEBAD9";
export const purple10 = "#EEE4F2";
export const purple05 = "#FBF9FD";

/*
 * System
 * Used sparingly for tags, highlights
 */
export const highlighter = "#FBF8E5";

/*
 * Shades
 */

export const white = "#ffffff";

/*
 * Social media icon colors
 */

export const facebookBlue = "#3C5A99";
export const twitterBlue = "#1DA1F2";
export const linkedInBlue = "#2867B2";

/*
 * The rest of the page is not part of the current Product Colors style guide.
 * Please clear with design before using for new products
 */
export const legacy = {
  babyBlue: "#d1e2f3",
  greenery: "#88b04b",
};
